import React, { useCallback, useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import JobScopeCreateForm from './JobScopeCreateForm';

const { PRIVATE_ROUTE } = API_ROUTES;

function JobScopeForm() {
  const {id} = useParams();
  const { authAxios } = useContext(FetchContext);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    control
  } = useForm({
    defaultValues: {
      name: '',
      remark: '',
    }});

  const getJobstatusFormById = useCallback(async () => {
    const { data } = await authAxios.get(
      `${PRIVATE_ROUTE.GET_JOBSCOPE_BY_ID}/${id}`
    );
    setValue('name', data?.data.name);
    setValue('remark', data?.data.remark);
  }, [authAxios, id, setValue]);

  useEffect(() => {
    if (id) {
      getJobstatusFormById();
    }
  }, [getJobstatusFormById, id]);

  const onSubmit = async (data) => {

    if (id) {
      const response = await authAxios.post(
        `${PRIVATE_ROUTE?.EDIT_JOBSCOPE}${id}`,
        data
      );
      toast.success(response.data.massage);
      navigate('/master/jobscope/list');
    } else {
      const response = await authAxios.post(PRIVATE_ROUTE?.CREATE_JOBSCOPE, data);
      if (response.data.statusCode === 200) {
        toast.success(response.data.massage);
        navigate('/master/jobscope/list');
      }
      else {
        toast.error(response.data.massage);
      }
    }
    setValue('name', '');
    setValue('remark', '');
  };
  return (
    <JobScopeCreateForm
      register={register}
      handleSubmit={handleSubmit}
      errors={errors}
      onSubmit={onSubmit}
      params={id}
      setValue={setValue}
      loading={isSubmitting}
      isEdit={id?"true":"false"}
      control={control}
    />
  );
}

export default JobScopeForm;
